module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "videos"
  }, [_c('div', {
    staticClass: "videos-header"
  }, [_vm._v("\n        NEWS VIDEOS\n    ")]), _vm._v(" "), (_vm.main) ? _c('div', {
    staticClass: "videos-main"
  }, [_c('a', {
    attrs: {
      "href": _vm.main.url
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openVideoModal(_vm.main)
      }
    }
  }, [_c('div', {
    staticClass: "videos-main-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.main.media_large
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "videos-main-title"
  }, [_vm._v("\n                " + _vm._s(_vm.main.title) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.extra.length) ? _c('div', {
    staticClass: "videos-list-container"
  }, _vm._l((_vm.extra), function(video) {
    return _c('div', {
      staticClass: "videos-list-element",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.openVideoModal(video)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": video.url
      }
    }, [_c('div', {
      staticClass: "videos-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": video.media_small
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "videos-element-title"
    }, [_c('div', {
      staticClass: "videos-element-category"
    }, [_vm._v("News")]), _vm._v(" "), _c('div', {
      staticClass: "videos-element-title-link"
    }, [_vm._v(_vm._s(video.title))])])])])
  })) : _vm._e(), _vm._v(" "), _c('video-modal', {
    attrs: {
      "open": _vm.videoModal,
      "close": _vm.closeVideoModal,
      "videoOpen": _vm.videoOpen
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a5ee64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/videos.vue
// module id = 181
// module chunks = 4